import { createApp } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility' // https://github.com/Akryum/vue-observe-visibility
import tooltip from './tooltip.js' // https://github.com/maciejziemichod/v-tooltip
import DistributorSearch from './DistributorSearch.vue'
import SeriesSearch from './SeriesSearch.vue'
import SeriesConfiguration from './SeriesConfiguration.vue'
import SeriesSelector from './SeriesSelector.vue'
import MaintenancePartsSearch from './MaintenancePartsSearch.vue'
import MaintenancePartsList from './MaintenancePartsList.vue'
import '@/assets/tooltip.css'

const distributorSearchApp = createApp(DistributorSearch)
window.distributorsearchapp = distributorSearchApp

const seriesSearchApp = createApp(SeriesSearch)
seriesSearchApp.directive('observe-visibility', {
  beforeMount: (el, binding, vnode) => {
    vnode.context = binding.instance
    ObserveVisibility.bind(el, binding, vnode)
  },
  update: ObserveVisibility.update,
  unmounted: ObserveVisibility.unbind
})
window.seriessearchapp = seriesSearchApp

const seriesConfigurationApp = createApp(SeriesConfiguration)
seriesConfigurationApp.directive('tooltip', tooltip)
window.seriesconfigurationapp = seriesConfigurationApp

const seriesSelectorApp = createApp(SeriesSelector)
window.seriesselectorapp = seriesSelectorApp

const maintenancePartsSearchApp = createApp(MaintenancePartsSearch)
window.maintenancepartssearchapp = maintenancePartsSearchApp

const maintenancePartsListApp = createApp(MaintenancePartsList)
window.maintenancepartslistapp = maintenancePartsListApp
